import axios from "axios";
import authApiConfig from "./authApiConfig";


const GlobalsService = {
    async getCodeArea () {
        return await authApiConfig.get("/codigo-area")
    },
    async getCovenantsBase() {
        return await axios.get(`${process.env.REACT_APP_API_BASE_CASC}/agenda/api/prevision`)
    },
    async getGenerosBase() {
        return await axios.get(`${process.env.REACT_APP_API_BASE_CASC}/agenda/api/genero`)
    }
}

export default GlobalsService;